/// <amd-module name="Test/TestPlansHubRefresh/TestCaseLinkedItems/Redux/TestCaseLinkedItemsReducer" />
import produce from "immer";
import {
    TestCaseLinkedItemsActions,
    TestCaseLinkedItemsActionsTypes
} from "Test/TestPlansHubRefresh/TestCaseLinkedItems/Redux/TestCaseLinkedItemsActions";
import { ILinkedItemsState, ITestSuiteItem } from "Test/TestPlansHubRefresh/TestCaseLinkedItems/Redux/TestCaseLinkedItemsContracts";

export function TestCaseLinkedItemsReducer(state: ILinkedItemsState, action: TestCaseLinkedItemsActions): ILinkedItemsState {
    state = state || ({} as ILinkedItemsState);

    return produce(state, (draftState: ILinkedItemsState) => {
        switch (action.type) {
            case TestCaseLinkedItemsActionsTypes.fetchLinkedTestSuitesSucceeded:
                const testSuiteItemList: ITestSuiteItem[] = [];
                const testSuiteList = action.payload.testSuites;
                for (let i = 0; i < testSuiteList.length; i++) {
                    testSuiteItemList.push({
                        plan: testSuiteList[i].plan.name,
                        title: testSuiteList[i].name,
                        project: testSuiteList[i].project.name,
                        suiteType: testSuiteList[i].suiteType,
                        suiteId: testSuiteList[i].id,
                        planId: testSuiteList[i].plan.id
                    });
                }
                draftState.testSuiteList = testSuiteItemList;
                draftState.loadingInProgress = false;
                break;

            case TestCaseLinkedItemsActionsTypes.fetchLinkedRequirementsSucceeded:
                draftState.linkedRequirementsList = action.payload.requirements;
                draftState.loadingInProgress = false;
                break;

            case TestCaseLinkedItemsActionsTypes.fetchLinkedBugsSucceeded:
                draftState.linkedBugsList = action.payload.bugs;
                draftState.loadingInProgress = false;
                break;

            case TestCaseLinkedItemsActionsTypes.changeSelectedTab:
                draftState.selectedTabId = action.payload.selectedTabId;
                draftState.loadingInProgress = true;
                break;

            default:
                break;
        }
    });
}
